/* globals Forms */
window['portal/registrations#new'] =
  window['portal/registrations#change_password'] = function () {
    Forms.initPasswordChecker()
  }
